import css from './cs_table_sort.module.scss'
import { parseString, formatNumber } from '../commons.js';
import ApplicationController from './application_controller.js'
export default class CsTableSortController extends ApplicationController {

  MODE_NONE = 0
  MODE_STRING = 1
  MODE_DATE = 2
  MODE_FLOAT = 3

  ORDER_ASC = 0
  ORDER_DESC = 1

  const_modes = {
    "string": this.MODE_STRING,
    "date": this.MODE_DATE,
    "float": this.MODE_FLOAT
  }

  connect() {
    this.evtL1 = this._evtHandleClick.bind(this)
    this.element.querySelector('thead').addEventListener('click', this.evtL1, false)
    this.modes = []
    this.sort_column = -1
    this.array_already_build = false
    if (this.element.dataset.headerRow === undefined)
      this.header_row = 0
    else
      this.header_row = parseInt(this.element.dataset.headerRow)
    this._setup_header()
  }

  _evtHandleClick(e) {
    var cliked_col_num = parseInt(e.target.dataset.colIndex)
    var order

    if (this.modes[cliked_col_num - 1] == this.MODE_NONE)
      return

    //console.log(e.target.dataset, cliked_col_num - 1, this.modes)

    if (cliked_col_num == this.sort_column)
      order = this.sort_order === this.ORDER_ASC ? this.ORDER_DESC : this.ORDER_ASC
    else
      order = this.ORDER_ASC

    this.element.rows[this.header_row].querySelectorAll('th').forEach((th, index) => {
      if (this.modes[index] != this.MODE_NONE) {
        th.classList.replace(css.active, css.inactive)
        th.classList.add(css.sort_default)
      }
    })
    e.target.classList.replace(css.inactive, css.active)
    e.target.classList.remove(css.sort_default)

    if (order == this.ORDER_ASC) {
      e.target.classList.add(css.sort_asc)
      e.target.classList.remove(css.sort_desc)
    } else {
      e.target.classList.add(css.sort_desc)
      e.target.classList.remove(css.sort_asc)
    }
    this._sort_table(cliked_col_num, order)
  }

  _setup_header() {
    this.element.rows[this.header_row].querySelectorAll('th').forEach((th, index) => {
      th.dataset.colIndex = index + 1
      if (th.dataset.sort === undefined)
        this.modes.push(this.MODE_NONE)
      else {
        this.modes.push(this.const_modes[th.dataset.sort])
        th.classList.add(css.sort_default)
        th.classList.add(css.inactive)
      }
      if (th.dataset.sortDefault != undefined) {
        //th.click()
      }
    })
  }

  _sort_table(col, order) {
    this.sort_column = col // Starts from 1 (0 reserved for tr dom element)
    this.sort_order = order
    if (this.array_already_build == false) {
      this._build_array()
      this.array_already_build = true
    }
    this._sort()
    this._rebuild_table()
    //console.table(this.values)
  }

  _rebuild_table() {
    this.element.getElementsByTagName("tbody")[0].innerHTML = ''
    this.values.forEach(ar_row => {
      this.element.querySelector('tbody').appendChild(ar_row[0])
    })
  }

  _build_array() {
    this.values = []
    this.element.querySelectorAll('tbody tr').forEach((row, index) => {
      //var row = this.element.rows[index]
      var ar_row = []
      ar_row.push(row)
      var ar_row_index = 0
      row.querySelectorAll('td').forEach(td => {
        var content = td.innerText
        switch (this.modes[ar_row_index]) {
          case this.MODE_DATE:
            var d = content.split('/') // Attention, ici gérer les formats US un jour
            var dt = new Date(parseInt(d[2]), parseInt(d[1]), parseInt(d[0])).valueOf()
            if (isNaN(dt))
              dt = 0
            ar_row.push(dt)
            break
          case this.MODE_FLOAT:
            ar_row.push(parseString(content))
            break
          default:
            ar_row.push(content)
            break
        }
        ar_row_index++
      })
      this.values.push(ar_row)
    })
  }

  _sort() {
    this.values.sort((a, b) => {
      if (this.modes[this.sort_column - 1] == this.MODE_STRING)
        return a[this.sort_column].localeCompare(b[this.sort_column])
      //a[this.sort_column] === b[this.sort_column]
      else
        return a[this.sort_column] - b[this.sort_column]
    })
    if (this.sort_order == this.ORDER_DESC)
      this.values.reverse()
  }


}